export enum ContrastTo {
  LightBackground = 'lightBackground',
  DarkBackground = 'darkBackground',
}

export enum State {
  Error = 'error',
}
